import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import './Widget.scss';
import './CompetitionWidgets/CompetitionWidgets.scss';
import './ColumnTableWidget.scss';

import NumberWidget from './NumberWidget';
import NumberWidgetBar from './NumberWidgetBar';
import NumberWidgetCircular from './NumberWidgetCircular';
import ColumnChartWidget from './ColumnChartWidget';
import ColumnChartWidgetGroup from './ColumnChartWidgetGroup';
import ColumnTableWidget from './ColumnTableWidget';
import NumberWidgetHalfCircular from './NumberWidgetHalfCircular';
import CustomHTMLWidget from './CustomHTMLWidget';
import PieChart from './PieChart';
import LineChart from './LineChart';
import colorHelper from '../../lib/colorLuminance';
import { widgetTitleFormatter, slideTitleFormatter } from '../../lib/titleFormatter';
import SaleCallTableWidget from './SaleCallTableWidget';
import SaleCallChartWidget from './SaleCallChartWidget';
import CompetitionBestTodayWidget from './CompetitionWidgets/CompetitionBestTodayWidget';
import CompetitionTopListWidget from './CompetitionWidgets/CompetitionTopListWidget';
import CompetitionCriteriasWidget from './CompetitionWidgets/CompetitionCriteriasWidget';
import CompetitionGoalWidget from './CompetitionWidgets/CompetitionGoalWidget';
import CompetitionTimeLeftWidget from './CompetitionWidgets/CompetitionTimeLeftWidget';

class Widget extends React.Component {
    getTitleClass(widget) {
        const columnWidgets = [
            'ColumnChartWidget',
            'ColumnChartWidgetGroup',
            'ColumnTableWidget',
            'PieChart',
        ];

        if (_.includes(columnWidgets, widget.displayType)) {
            return 'widget_title';
        }

        return 'widget_title override_colorprofile_color';
    }

    startEditing() {
        if (this.props.startEditing) {
            this.props.startEditing(this.props.widget._id);
        }
    }

    render() {
        const { widget, widgetData, rowHeight, companyProfile, isPlaying, currency, isThumbnail, isCompetition, slide } = this.props;

        const widgets = {
            ColumnChartWidget,
            ColumnChartWidgetGroup,
            ColumnTableWidget,
            NumberWidget,
            NumberWidgetBar,
            NumberWidgetCircular,
            NumberWidgetHalfCircular,
            CustomHTMLWidget,
            PieChart,
            LineChart,
            SaleCallChartWidget,
            SaleCallTableWidget,
            CompetitionBestTodayWidget,
            CompetitionTopListWidget,
            CompetitionGoalWidget,
            CompetitionTimeLeftWidget,
            CompetitionCriteriasWidget,
        };

        moment.locale('sv');

        let title;

        if (_.get(widget, 'displayConfig.customTitle')) {
            title = slideTitleFormatter(widget.displayConfig.customTitle);
        } else if (widget.title) {
            title = widget.title;
        } else {
            title = widgetTitleFormatter(widget);
        }

        const titleClass = this.getTitleClass(widget);

        const colorprofile = {};

        if (companyProfile) {
            const lighterColor = colorHelper.colorLuminance(companyProfile.colors.mainBg, 0);
            colorprofile.color = lighterColor; // this.props.companyProfile.secondary;
        }

        let settingsButtonClasses = 'settingsButton';
        if (isPlaying || isThumbnail || isCompetition) {
            settingsButtonClasses += ' hide';
        }

        let ThisWidget;

        //explicit check for saleCallChart and saleCallTable 
        //because their charts are different than normal ones        
        if (widget.dataType === 'saleCall') {
            if (widget.displayType === 'ColumnChartWidget') {
                ThisWidget = SaleCallChartWidget;
            } else {
                ThisWidget = SaleCallTableWidget;
            }
        } else {
            ThisWidget = widgets[widget.displayType];
        }

        if (!ThisWidget) {
            return (
                <div className={widget.displayType}>
                    {!isThumbnail && <div className={settingsButtonClasses} onClick={() => { this.startEditing(); }}>
                        <i className="fa fa-cog fa-2x" />
                    </div>}
                </div>);
        }

        return (
            <div className={widget.displayType}>
                {(!isThumbnail || !isCompetition) && <div className={settingsButtonClasses} onClick={() => { this.startEditing(); }}>
                    <i className="fa fa-cog fa-2x" />
                </div>}
                {!isThumbnail && !isCompetition && <h4 className={titleClass} style={colorprofile}>{title}</h4>}
                <ThisWidget
                    widget={widget}
                    widgetData={widgetData}
                    rowHeight={rowHeight}
                    companyProfile={companyProfile}
                    currency={currency}
                    isThumbnail={isThumbnail}
                    slide={slide}
                />
            </div>
        );
    }
}

Widget.propTypes = {
    widget: React.PropTypes.object,
    widgetData: React.PropTypes.array,
    companyProfile: React.PropTypes.object,
    rowHeight: React.PropTypes.number,
    isPlaying: React.PropTypes.bool,
    startEditing: React.PropTypes.func,
    slideId: React.PropTypes.string,
    currency: React.PropTypes.string,
    isThumbnail: React.PropTypes.bool,
    isCompetition: React.PropTypes.bool,
    slide: React.PropTypes.object,
};

export default Widget;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/Widget.jsx
 **/